import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { fmtDate } from "./adminUtils";
import { User } from "lucide-react";

export const AssetHistoryDialog = ({ open, onClose, title, history }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-[460px]" data-testid="asset-history-dialog">
      <DialogHeader>
        <DialogTitle>Storico assegnazioni</DialogTitle>
        <DialogDescription className="text-[13px] text-gray-600">{title}</DialogDescription>
      </DialogHeader>
      {(!history || history.length === 0) ? (
        <p className="text-[13px] text-gray-500 py-3">Nessuna assegnazione registrata.</p>
      ) : (
        <div className="relative pl-4 border-l-2 border-gray-200 space-y-3 py-1">
          {history.slice().reverse().map((h, i) => (
            <div key={`${h.assigned_at || ""}-${h.employee_name || ""}-${i}`} className="relative">
              <span className="absolute -left-[21px] top-1 w-3 h-3 rounded-full border-2 border-white" style={{ backgroundColor: h.ended_at ? "#9ca3af" : "#16a34a" }} />
              <div className="text-[13px] font-bold text-[#16345c] flex items-center gap-1.5"><User size={13} className="text-gray-400" /> {h.employee_name || "—"}</div>
              <div className="text-[11.5px] text-gray-500">
                Dal {fmtDate(h.assigned_at)} {h.ended_at ? `al ${fmtDate(h.ended_at)}` : "· in corso"}
                {h.note ? ` · ${h.note}` : ""}
              </div>
            </div>
          ))}
        </div>
      )}
    </DialogContent>
  </Dialog>
);
